import { GET_LAYOUT_MAX_WIDTH } from '../../../../constants/layout';
import Placeholder from '../../../../elements/Placeholder';
import { getFontScale } from '../../../../utils/layoutHelpers';
import { getOnSaleListHeight } from '../styles';
import S, {
  BACKGROUND_PADDING_VERTICAL,
  BODY_MARGIN_TOP,
  CONTAINER_PADDING_BOTTOM,
  HEAD_HEIGHT,
  MARGIN_HORIZONTAL,
  PADDING_HORIZONTAL,
} from './styles';

const ITEM_COUNT = 4;
const ITEM_SPACE = 2;

export default () => {
  const layoutMaxWidth = GET_LAYOUT_MAX_WIDTH();

  const containerSpace = (PADDING_HORIZONTAL + MARGIN_HORIZONTAL) * 2;
  const itemWidth = (layoutMaxWidth - containerSpace) / ITEM_COUNT - ITEM_SPACE;

  const totalHeight = getOnSaleListHeight(getFontScale());

  return (
    <S.Container height={totalHeight}>
      <S.Background>
        <S.Head>
          <Placeholder width={50} height={14} />
          <Placeholder width={93} height={20} />
          <Placeholder width={50} height={14} />
        </S.Head>
        <S.Body>
          {Array(ITEM_COUNT)
            .fill('on-sale-item')
            .map((key, index) => {
              const marginLeft = index === 0 ? 0 : ITEM_SPACE;
              const height =
                totalHeight -
                HEAD_HEIGHT -
                CONTAINER_PADDING_BOTTOM -
                BACKGROUND_PADDING_VERTICAL * 2 -
                BODY_MARGIN_TOP;

              return (
                <Placeholder
                  key={`${key}-${index}`}
                  width={itemWidth}
                  height={height}
                  boxStyle={{ width: itemWidth, marginLeft }}
                />
              );
            })}
        </S.Body>
      </S.Background>
    </S.Container>
  );
};
